import { useState } from "react";
import "./LstMenu.scss";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";
import UtilServices from "@services/UtilServices";

export default function LstMenu({
  open = false,
  setOpen = () => null,
  openpai = false,
  setOpenPai = () => null,
  onClick = () => null,
  theme = "1",
  className = "",
  title = "",
  width = "130px",
  flgsublst = false,
  flglstfilho = false,
  lst = [
    {
      id: "1",
      desc: "RPAs",
      icon: '<i class="fa-regular fa-robot"></i>',
      ativo: false,
      onClick: () => {
        alert("teste");
      },
    },
  ],
  menuRef = null,
}) {
  const [lista, setLista] = useState(lst);
  const [openPaiId, setOpenPaiId] = useState(null);

  function handleClick(e) {
    // Reseta a lista e ativa o item clicado
    const novaLista = lista
      .map((item) => ({
        ...item,
        ativo: false, // primeiro reset
      }))
      .map((item) => ({
        ...item,
        ativo: item?.id === e?.id || (e?.id_pai && item?.id_pai === e?.id_pai), // ativa o correto
      }));

    setLista(novaLista);
    setOpen(false);
    // Retorno.
    onClick(e);
  }

  return (
    <div ref={menuRef} className={`lstmenu theme${theme} ${className}`}>
      {!flglstfilho && (
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            color: "var(--color-01)",
          }}
        >
          {title && <p style={{ fontFamily: "Roboto Light" }}>{title}</p>}
          <ButtonIcon
            Arrow
            classNameArrow="clicou-menu"
            openSetArrow={open}
            setOpenSetArrow={setOpen}
            onArrow={() => {
              setOpen(!open);
            }}
          />
        </div>
      )}
      {/* list pai*/}
      {open && flgsublst && (
        <div className="lista pai">
          {lista.map((item, index) => (
            <>
              <div
                key={index} // Adicionando chave única para cada item
                className={`itens clicou-menu ${item?.class}`}
                onClick={() => {
                  setOpenPaiId(openPaiId === item.id_pai ? null : item.id_pai);

                  if (!item?.flgsublst) {
                    handleClick(item);
                    if (typeof item?.onClick === "function") {
                      item?.onClick();
                    }
                  }
                }}
                style={{ width: width }}
              >
                <div
                  style={{ display: "flex", gap: "10px", alignItems: "center" }}
                >
                  <span>{UtilServices.stringToJsx(item?.icon_pai)} </span>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <p
                      className="desc1 clicou-menu"
                      style={{ fontFamily: "Roboto Light" }}
                    >
                      {item?.desc_pai}
                    </p>
                    {item?.flgsublst && (
                      <ButtonIcon
                        Arrow
                        classNameArrow="clicou-menu"
                        openSetArrow={openPaiId === item.id_pai}
                      />
                    )}
                  </div>
                </div>
                {item?.flgsublst && (
                  <LstMenu
                    flglstfilho={true}
                    flgsublst={false}
                    openpai={openPaiId === item.id_pai}
                    setOpen={setOpen}
                    width="220px"
                    lst={item.lst_filho}
                  />
                )}
              </div>
            </>
          ))}
        </div>
      )}
      {/* sem sub listas */}
      {open && !flgsublst && !flglstfilho && (
        <div className="lista">
          {lista.map((item, index) => (
            <div
              key={index} // Adicionando chave única para cada item
              className={`itens clicou-menu ${item?.class}`}
              onClick={() => {
                handleClick(item);
                if (typeof item?.onClick === "function") {
                  item?.onClick();
                }
              }}
              style={{ width: width }}
            >
              <div
                style={{ display: "flex", gap: "10px", alignItems: "center" }}
              >
                <span>{UtilServices.stringToJsx(item?.icon)} </span>
                <div>
                  <p
                    className="desc1 clicou-menu"
                    style={{ fontFamily: "Roboto Light" }}
                  >
                    {item?.desc}
                  </p>
                  <p
                    className="desc2 clicou-menu"
                    style={{ fontFamily: "Roboto Light" }}
                  >
                    {item?.desc2}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {/* lista filho */}
      {openpai && flglstfilho && (
        <div
          className="lista filho clicou-menu"
          style={{
            left: `${parseInt(width, 10) + 5}px`,
            top: "-35px",
          }}
        >
          {lista.map((item, index) => (
            <div
              key={index} // Adicionando chave única para cada item
              className={`itens clicou-menu ${item?.class}`}
              onClick={() => {
                handleClick(item);
                if (typeof item?.onClick === "function") {
                  item?.onClick();
                }
              }}
              style={{ width: width }}
            >
              <div
                style={{ display: "flex", gap: "10px", alignItems: "center" }}
              >
                <span>{UtilServices.stringToJsx(item?.icon)} </span>
                <div>
                  <p
                    className="desc1 clicou-menu"
                    style={{ fontFamily: "Roboto Light" }}
                  >
                    {item?.desc}
                  </p>
                  <p
                    className="desc2 clicou-menu"
                    style={{ fontFamily: "Roboto Light" }}
                  >
                    {item?.desc2}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
